module.exports = __webpack_public_path__ + "static/img/fullscreen-image_training.d2528da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_training.png
// module id = rrTO
// module chunks = 0